import { useOrderFormStore } from '@/modules/order/stores/order-form.store'
import useOrderFormParams from '@/modules/order/hooks/use-order-form-params.hook'
import type { TProducts } from '../types/product.type'

export const useCalculationProductDetails = (product: TProducts) => {
  const { jsonOrderForm } = useOrderFormStore()
  const { descontoItemSobrescreveGeral, utilizaValorSugerido } = useOrderFormParams()

  const checkIfProductIsActivePromotion = () => {
    if (product.flagPromocao) {
      return product.valorPromocao
    }

    return utilizaValorSugerido ? product.valorSugerido : product.valorTabela
  }

  const calcUnitaryValueWithDiscount = (currentValue: number) => {
    if (product) {
      const valueToCalculation = checkIfProductIsActivePromotion()

      const newUnitaryValueBase = valueToCalculation * (1 - currentValue / 100)

      let newUnitaryValue = newUnitaryValueBase
      if (!descontoItemSobrescreveGeral) {
        newUnitaryValue =
          newUnitaryValueBase * (1 - jsonOrderForm?.descTotal / 100)
      }

      return {
        newUnitaryValue,
        newUnitaryValueBase,
      }
    }
  }

  const calcDiscountWithUnitaryValue = (currentValue: number) => {
    if (product && jsonOrderForm) {
      const valueToCalculation = checkIfProductIsActivePromotion()

      let totalDiscountInOrder = valueToCalculation
      if (!descontoItemSobrescreveGeral) {
        totalDiscountInOrder = valueToCalculation * (1 - jsonOrderForm.descTotal / 100)
      }

      if (totalDiscountInOrder <= 0) {
        return {
          newUnitaryValue: 0,
          newUnitaryValueBase: 0,
        }
      }

      const newUnitaryValue = (1 - currentValue / totalDiscountInOrder) * 100

      const newUnitaryValueBase =
        valueToCalculation * (1 - newUnitaryValue / 100)

      return {
        newUnitaryValue: Math.max(newUnitaryValue, 0),
        newUnitaryValueBase,
      }
    }
  }

  return {
    calcUnitaryValueWithDiscount,
    calcDiscountWithUnitaryValue,
  }
}
